import get from 'lodash/get';
import moment from 'moment';
import { adressFullStringGetter, getAdresseByGescomAdresse } from '@/services/general/adresseManager';
import genererPanneau from '@/services/recommandation/genererPanneau';
import { isLigneLocation } from '@/services/recommandation/gestionEcheancier';
import { FORFAIT_HONORAIRES_CATEGORIE, HONORAIRES_CATEGORIE, CATEGORIE_DIVERS, ANNEE } from '@/configurations/recomConfig';
import calculArrondi from '@/services/general/calculArrondi';
import { calculNetBudget } from '@/services/recommandation/calculRemisePanneau';
import { calculerNbreAnnees } from '@/services/general/calculDataLigne';

export function transformProduitToPanneau(produit, fournisseur) {
  const panneau = { ...genererPanneau(), id: produit.id, guid: produit.guid || produit.id };
  if (produit.categorieVente !== CATEGORIE_DIVERS) {
    panneau.regieId = get(fournisseur, 'id', null);
    panneau.srcImg = get(produit, 'srcImg', null);
    panneau.urlLogo = get(produit, 'urlLogo', null);
    panneau.azimut = get(produit, 'produitFace.azimut', 0);
    panneau.regie = get(fournisseur, 'nomCommercial', null);
    panneau.format = get(produit, 'produitFace.format', null);
    panneau.formatId = get(produit, 'produitFace.formatId', null);
    panneau.materiel = get(produit, 'produitFace.materielType', null);
    panneau.referenceConfrere = get(produit, 'referenceConfrere', '');
    panneau.adresse = getAdresseByGescomAdresse(get(produit, 'produitFace.adresse', null));
    panneau.adresseCommerciale = adressFullStringGetter(get(produit, 'produitFace.adresse', null));
    panneau.referencePanneau = get(produit, 'reference', '');
  }
  return panneau;
}

export function getCategorieFromProduit(lignesCommande) {
  const ligneCommandeLocation = lignesCommande.find(isLigneLocation);
  if (!ligneCommandeLocation) return null;
  const { produit } = ligneCommandeLocation;
  return {
    id: produit.id,
    libelle: produit.libelle,
    couleur: produit.couleurHtmlRgb
  };
}

export function isCategorieHonoraire(categorie) {
  if (!categorie) return false;
  return [FORFAIT_HONORAIRES_CATEGORIE, HONORAIRES_CATEGORIE].includes(categorie.libelle)
}

export function updateDataBudgetGenerationByBudgets(budgets, budgetGeneration) {
  if (!budgets || !budgets.length) return;

  const sorted = [...budgets].sort((a, b) => new Date(a.dateDebut) - new Date(b.dateDebut));
  const premier = sorted.find(element => element.dateDebut != null);
  const dernier = sorted[sorted.length - 1];
  budgetGeneration.dateDebut = premier.dateDebut;
  budgetGeneration.dateFin = dernier.dateFin;
  const dateFinPremiere = sorted.length > 1 ? premier.dateFin : null;
  budgetGeneration.dateFinPremiereEcheance = dateFinPremiere
    && moment(dateFinPremiere).isAfter(moment(premier.dateDebut))
    && moment(dateFinPremiere).isBefore(moment(dernier.dateFin))
    ? dateFinPremiere
    : null;

  const coeff = calculerNbreAnnees(dernier.dateDebut, dernier.dateFin);
  if (coeff && coeff > 0) {
    budgetGeneration.prixBrutNegocie = calculArrondi(dernier.prixBrutNegocie / coeff, 5);
  }

  budgetGeneration.remise = { ...dernier.remise };
  budgetGeneration.uniteQteBrut = dernier.uniteQteBrut || ANNEE;
  budgetGeneration.uniteQteTlpe = dernier.uniteQteTlpe || ANNEE;
  budgetGeneration.prixTotal = budgets.reduce((acc, budget) => acc + budget.prixTotal, 0);
  budgetGeneration.montantMoyen = budgets.reduce((acc, budget) => acc + budget.prixUnitaireBrut, 0) / budgets.length;
  calculNetBudget(budgetGeneration);
}